import React, { useState } from 'react';

import { useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import InformationIcon from '@atlaskit/icon/core/migration/information--editor-panel';
import Popup from '@atlaskit/popup';
import { Box, xcss } from '@atlaskit/primitives';
import { layers } from '@atlaskit/theme/constants';

import { HintPopupMessages } from './messages';

const popupStyles = xcss({
	paddingBlock: 'space.100',
	paddingInline: 'space.200',
	maxWidth: '360px',
});

export const HintPopup: React.FC<{ hint: string; label: string }> = ({ hint, label }) => {
	const { formatMessage } = useIntl();

	const [isOpen, setIsOpen] = useState(false);

	return (
		<Box
			onKeyDown={(e: React.KeyboardEvent) => {
				if (e.key === 'Escape' && isOpen) {
					e.nativeEvent.stopImmediatePropagation();
					setIsOpen(false);
				}
			}}
		>
			<Popup
				isOpen={isOpen}
				placement="right"
				zIndex={layers.tooltip()}
				onClose={() => setIsOpen(false)}
				content={() => <Box xcss={popupStyles}>{hint}</Box>}
				shouldRenderToParent
				trigger={(triggerProps) => (
					<IconButton
						{...triggerProps}
						label={formatMessage(HintPopupMessages.MoreInfoIconLabel, {
							fieldName: label,
						})}
						appearance="subtle"
						isSelected={isOpen}
						onClick={() => setIsOpen(!isOpen)}
						icon={(iconProps) => (
							<InformationIcon
								{...iconProps}
								color="currentColor"
								LEGACY_size="small"
								size="small"
							/>
						)}
						aria-haspopup="true"
						aria-expanded={isOpen}
						spacing="compact"
					/>
				)}
			/>
		</Box>
	);
};
